import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

export default function MetaPill({
    icon,
    children,
    className = '',
    ...rest
}) {
    return (
        <span className={classNames('meta-pill', className)} {...rest}>
            {icon ? <span className="meta-pill__icon" aria-hidden="true">{icon}</span> : null}
            <span className="meta-pill__label">{children}</span>
        </span>
    );
}

MetaPill.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
